import { Layout } from 'components/layout';

import { ReviewsTables } from './reviews';

import { CustomMetadata } from 'components/metadata';

import { ReviewHeader } from 'components/review-header';
import { allMetadata } from 'constants/metadata';

import { Routes } from 'constants/routes';
import { ICasino } from 'constants/types';

import { Breadcrumbs } from 'components/bredcrambs';
import { NotVerifiedReviewsBlock } from 'components/not-verified-reviews-block';
import { BreadcrumbsProps, reviewsSlot } from 'constants/routes-breadcrumbs';
import { useSlotReviewsByCasinoQuery } from 'hooks/api/slot_reviews';
import { getItemIdentifier } from 'utils/slug';
import styles from './styles.module.css';

export type Props = {
  casino: ICasino;
};

export const ReviewSlot = ({ casino }: Props) => {
  const { isFetching } = useSlotReviewsByCasinoQuery(
    { casino_id: casino?._id?.toString() ?? '' },
    { skip: !casino?._id }
  );

  if (!casino) {
    return <div>No casino data found.</div>;
  }

  return (
    <div className="wrapper">
      <CustomMetadata metadata={allMetadata.casinoSlotReviews(casino)} />
      <Layout hasFooter isSearchInputMobileVisible>
        <main className={styles.main}>
          <Breadcrumbs
            items={[
              ...reviewsSlot,
              {
                id: 2,
                path: Routes.casinoPage(getItemIdentifier(casino)),
                title: casino?.name,
              } as BreadcrumbsProps,
              {
                id: 3,
                path: `#`,
                title: 'Slots RTP Reviews',
              } as BreadcrumbsProps,
            ]}
          />
          <div className={styles.wrapper_tables}>
            <ReviewHeader
              casino={casino}
              type="casino-slots"
              name={casino?.name}
              link={casino?.link_play}
              logoUrl={casino?.logoUrl}
              imageUrl={casino?.imageUrl}
              reviewsCount={casino?.slots_reviews_count}
            />
            <ReviewsTables noLimit casino={casino} />

            {!isFetching && <NotVerifiedReviewsBlock casinoId={casino?._id} />}
          </div>
        </main>
      </Layout>
    </div>
  );
};
